import { useParams } from 'react-router-dom';
import { DayKey } from '../../../Shared/Services/TimefitBackend';

export function useSelectedDayKey() {
  const params = useParams();
  return params.day as DayKey;
}
